/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ScorecardDefinitionOut } from './scorecardDefinitionOut';
import type { ScorecardFillOut } from './scorecardFillOut';

export interface ScorecardFillGroup {
  definition: ScorecardDefinitionOut;
  fills: ScorecardFillOut[];
  hidden_count: number;
  in_resolved_set: boolean;
}
